import { ca } from '../i18n/ca';

/**
 * One short sentence of help and the rest folded away under «Com funciona», so a page
 * that explains itself in three sentences shows one until somebody asks for the others.
 */
export function HelpMore({ short, more }: { short: string; more: string }) {
  return (
    <>
      <p className="muted small">{short}</p>
      <details className="identities">
        <summary className="muted small">{ca.howItWorksLabel}</summary>
        <p className="muted small">{more}</p>
      </details>
    </>
  );
}
